// images
import blogImg1 from "../images/thumbnail/TEDX_Thumbnail_small.webp";
import blogImg2 from "../images/thumbnail/Beyond_US_Thumbnail_Small.webp";
import blogImg3 from "../images/thumbnail/Domestic_Growth_small.webp";
import blogImg4 from "../images/thumbnail/Azam_Campus_Thumbnail_Small.webp";

import blogSingleImg1 from "../images/thumbnail/TEDX_Thumbnail_Big.webp";
import blogSingleImg2 from "../images/thumbnail/Beyond_US_Thumbnail_Big.webp";
import blogSingleImg3 from "../images/thumbnail/Domestic_Growth_Big.webp";
import blogSingleImg4 from "../images/thumbnail/Azam_Campus_Thumbnail_Big.webp";

const blogs = [
  {
    id: "1",
    title: "You Don't Need To Be Rich To Study Abroad",
    screens: blogImg1,
    description:
      "Discover how thousands of students are pursuing international education without coming from wealthy backgrounds.",
    author: "Asslam Shaikh",
    thumb: "TEDx Talk",
    create_at: "TEDx Talk",
    blogSingleImg: blogSingleImg1,
    comment: "Watch Full Talk",
    blClass: "format-video",
    mediaRedirectLink: "https://www.youtube.com/watch?v=RigG0dH_tOY",
  },
  {
    id: "2",
    title: "Building India's Most Accessible Study Abroad Ecosystem",
    screens: blogImg2,
    description:
      "How technology, transparency, and expert guidance are changing the way students approach overseas education.",
    author: "Asslam Shaikh",
    thumb: "Media Interview",
    create_at: "Media Interview",
    blogSingleImg: blogSingleImg2,
    comment: "Read Full Story",
    blClass: "format-standard-image",
    mediaRedirectLink:
      "https://www.tribuneindia.com/news/business/renowned-overseas-education-expert-asslam-shaikh-says-we-need-to-think-beyond-the-u-s/",
  },
  {
    id: "3",
    title: "From Counselor to Global Education Leader",
    screens: blogImg3,
    description:
      "The entrepreneurial journey behind building one of India's fastest-growing international education networks.",
    author: "Asslam Shaikh",
    thumb: "Leadership Feature",
    create_at: "Leadership Feature",
    blogSingleImg: blogSingleImg3,
    comment: "Read Full Article",
    blClass: "format-standard-image",
    mediaRedirectLink:
      "https://www.mid-day.com/buzzfeed/article/education-expert-aslam-shaikh-champions-education-for-all-sections-of-community-at-pune-alumni-meet-8175",
  },
  {
    id: "4",
    title: "The Rise of Edupreneurship in India",
    screens: blogImg4,
    description:
      "Asslam Shaikh shares how entrepreneurs can build impactful businesses while helping students achieve global careers.",
    author: "Asslam Shaikh",
    thumb: "Panel Discussion",
    create_at: "Panel Discussion",
    blogSingleImg: blogSingleImg4,
    comment: "Read Full Article",
    blClass: "format-standard-image",
    mediaRedirectLink:
      "https://www.mid-day.com/buzzfeed/article/education-expert-aslam-shaikh-champions-education-for-all-sections-of-community-at-pune-alumni-meet-8175",
  },
];
export default blogs;
